import { layoutOf } from "../../domain/layout";
import { singleAxle } from "../wheel-placements";
import { JCB } from "./dimensions";
const JCB_4_LAYOUT = layoutOf(["single", "single"]);
const JCB_4_WHEELS = [
  ...singleAxle({
    axle: 1,
    x: JCB.frontAxleX,
    radius: JCB.frontWheelRadius,
    width: JCB.frontTyreWidth,
    halfTrack: JCB.frontHalfTrack
  }),
  ...singleAxle({
    axle: 2,
    x: JCB.rearAxleX,
    radius: JCB.rearWheelRadius,
    width: JCB.rearTyreWidth,
    halfTrack: JCB.rearHalfTrack
  })
];
export {
  JCB_4_LAYOUT,
  JCB_4_WHEELS
};
